import { Component} from '@angular/core';
import { NavController, NavParams,ViewController,Events} from 'ionic-angular';
import {CollectionAndClasses} from '../../providers/config';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-items-modal',
  templateUrl: 'items-modal.html',
})
export class ItemsModalPage {

	collection :any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private gVLogger: GVLogger,
  	private view:ViewController,
  	private events:Events) {
  	this.collection = this.navParams.data.collection;
  	this.gVLogger.log(this.collection);
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ItemsModalPage');
  }

  closePopover(){

  	this.view.dismiss();
  }


  populateSubCategory(sub){
  	CollectionAndClasses.collection = [0];
    CollectionAndClasses.subCollection=[sub.id];
    CollectionAndClasses.categories=[0];
    CollectionAndClasses.tags=[0];
    this.events.publish("Items:Refreshed");
    this.closePopover();
  }

}



// WEBPACK FOOTER //
// ./src/pages/items-modal/items-modal.ts